module.exports = __webpack_public_path__ + "static/media/sasb.a0f85374.svg";